const React = require('react');
import GreySpaceCardMainContainer from './greySpaceCard.jsx';
const ReduxStore = require('./redux/reduxStore.jsx.js');
const SharedConstants = require('../../../shared/sharedConstants');
const AjaxFunctions = require('./ajaxFunctions');
const AdminAjaxFunctions = require('./adminAjaxFunctions');
const ToastAlert = require('./components/toastAlert');

export class ConjectureReview extends React.Component{
   constructor(props) {
      super(props);
      this.state = {
      }
   }

   componentDidMount(){
      ReduxStore.store.dispatch(ReduxStore.GreySpaceCardFunctions.setCurrentCard(this.props.curCard));
   }

   render() {
      return (
         <div id='conjectureReviewContainer'>
            <div>
               <GreySpaceCardMainContainer
                  userData={{}}
                  isReviewing={true}
                  showAdditionalFunctions={false}
               />
               <hr style={{'paddingTop': '10px', 'paddingBottom': '10px'}} />
               <ApprovalControl
                  cardType={SharedConstants.CardType.Reasoning}
                  idCard={this.props.curCard.id}
                  closeFunction={this.props.closeFunction}
               />
            </div>
         </div>
      );
   }
};


export class ApprovalControl extends React.Component{
   constructor(props) {
      super(props);
      this.state = {
      }
   }

   submitCardVote(bVal) {
      const { idCard, cardType } = this.props;
      if (window.globals.isSponsor || window.globals.isAdmin) {
         if (bVal) {
            AdminAjaxFunctions.manuallyApproveConjecture(idCard).then(() => {
               ToastAlert.success('Instantly approved conjecture.');
               this.props.closeFunction();
            });
         } else {
            AdminAjaxFunctions.manuallyRejectConjecture(idCard, 'Rejected by a site admin or sponsor').then(() => {
               ToastAlert.success('Instantly rejected conjecture.');
               this.props.closeFunction();
            });
         }
      } else {
         let approvalData = {
            q1VoteType: !bVal,
            q2VoteType: false,
            q3VoteType: false,
            idCard,
            cardType,
         };
         AjaxFunctions.createCardApproval(approvalData).then( () => {
            ToastAlert.success('Vote Submitted.');
            this.props.closeFunction();
         });
      }
   }

   render() {
      return(
         <div className='approval-control-container'>
            <div>
               <ApprovalQuestion
                  text={'Conjecture should not contain objectionable, unprofessional, rude, or other similar content.'}
                  setDataFunction={bVal => this.submitCardVote(bVal)}
               />
            </div>
         </div>
      );
   }
}

class ApprovalQuestion extends React.Component{
   constructor(props) {
      super(props);
      this.state = {
      }
   }

   render() {
      return(
         <div className="conjecture-review-question">
            {this.props.title && <h6><strong>{this.props.title}</strong></h6>}
            <div className='review-buttons'>
               <div
                  className={'review-btn review-btn-yes'}
                  onClick={() => this.props.setDataFunction(true)}
               >
                  Approve
               </div>
               <div
                  className={'review-btn review-btn-no'}
                  onClick={() => this.props.setDataFunction(false)}
               >
                  Reject
               </div>
            </div>
            <div className={'card'}>
               <div className={'card-body'}>
                  <div>Remember, good &micro;Pubs. . .</div>
                  <ul>
                     <li>{this.props.text}</li>
                  </ul>
               </div>
            </div>
         </div>
      );
   }
}
